// Entry point for the unpkg bundle containing custom model definitions.
//
// It differs from the notebook bundle in that it does not need to define a
// dynamic baseURL for the static assets and may load some css that would
// already be loaded by the notebook otherwise.

// Export widget models and views, and the npm package version number.
export * from "./figure";
export * from "./tf";
export * from "./scatter";
export * from "./volume";
export * from "./mesh";
export * from "./utils";
export * from "./selectors";
export * from "./values";
export {semver_range as version} from "./utils";
